/**
 * Class string for NATIVE `<select>` elements in the lease-input forms (pets, assistance animals).
 *
 * The shared `ui/select` is a Radix listbox, not a native `<select>`; the native element is kept
 * here on purpose (mobile pickers, `selectOption`-driven tests), so its 16px-on-mobile /
 * 44px-target styling lives in ONE place instead of a copy per component. Text inputs and
 * textareas use the shared `Input` / `Textarea` components directly.
 */
export const nativeSelectClass =
  'w-full px-3 py-2.5 text-base md:text-sm border border-input rounded-md bg-background text-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring min-h-[44px]';
